import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import {
  getPublishedGuideBySlug,
  getPublishedGuides,
  getRelatedPublishedGuides,
} from "./guides.server";

export const listPublishedGuides = createServerFn({ method: "GET" }).handler(async () => {
  return getPublishedGuides();
});

export const loadPublishedGuidePage = createServerFn({ method: "GET" })
  .inputValidator(z.object({ slug: z.string().min(1) }))
  .handler(async ({ data }) => {
    const guide = getPublishedGuideBySlug(data.slug);
    if (!guide) return null;
    return { guide, related: getRelatedPublishedGuides(guide.relatedSlugs) };
  });
